<template functional>
    <div class="text-base text-dark">
        <template v-if="props.isDistributor">
            <div class="mb-2 flex">
                <span>同行</span>
                <span class="text-price font-medium ml-1">
                    {{ props.trade_price ? `￥${props.trade_price}` : "-" }}
                </span>
            </div>
            <div class="flex">
                <span>零售</span>
                <span class="text-sm font-medium leading-[1.5rem] ml-1">
                    {{ props.price ? `￥${props.price}` : "-" }}
                </span>
            </div>

        </template>
        <div v-else>
            <span class="font-medium" :class="[, props.price ? `text-price` : '']">
                {{ props.price ? `￥${props.price}` : "-" }}
            </span>
        </div>
    </div>
</template>
<script>
import {
    defineComponent,
} from "@nuxtjs/composition-api";
export default defineComponent({
    name: 'TablePriceCell',
    props: {
        price: [String, Number],
        trade_price: [String, Number],
        isDistributor: Boolean
    }
})
</script>
